import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import moment from 'moment-timezone';
import { SdfAlert, SdfButton, SdfShimmer } from '@synerg/react-components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


export function RequestManageCertficate({ alertTitle, alertBody, request, isProjectDetailPage = false }) {

	const history = useHistory();
	const gotoCertificate = (generateCert) => {
		history.push({
			pathname: '/certificate',
			...(generateCert && ({
                hash: 'generate'
            }))
		});
	};

	if (isProjectDetailPage) {
		return (
			<>
				<span slot="title">{alertTitle}</span>
				<div>{alertBody}</div>
				<div className="mt-4">
					<SdfButton emphasis="secondary" onClick={() => { gotoCertificate(request) }}>
						{request ? "Request certificate" : "Manage certificate"}
					</SdfButton>
				</div>
			</>
		)
	}

	else {
		return (
			<>
				<div slot="title" >{alertTitle}</div>
				<div>{alertBody}</div>
				<SdfButton slot="action" className="whitespace-nowrap" emphasis="secondary" onClick={() => gotoCertificate(request)}>
					{request ? "Request certificate" : "Manage certificate"}
				</SdfButton>
			</>
		)
	}
};


export const getExpiresIn = (expiryDate) => moment.tz(expiryDate, 'America/New_York').diff(moment.tz(new Date(), 'America/New_York'), 'days');

export const getActiveExpiredCertInfo = (certificates) => {
	let activeCertificates = 0;
	let expiredCertificates = 0;
	let processingCertificates = 0;
	let failedCertificates = 0;
	certificates.forEach((certificateInformation) => {
		if (certificateInformation.status === 'active') {
			if (getExpiresIn(certificateInformation.expires) < 1)
				expiredCertificates++;
			else
				activeCertificates++;
		}
		else if (certificateInformation.status === 'processing') {
			processingCertificates++;
		}
		else if (certificateInformation.status === 'failed') {
			failedCertificates++;
		}
	})

	return { activeCerts: activeCertificates, expiredCerts: expiredCertificates, processingCerts: processingCertificates, failedCerts: failedCertificates }
};

function CertificateAlert({ handleError }) {
	const [alertLoading, setAlertLoading] = useState(true);
	const [certificates, setCertificates] = useState([]);

	const fetchCertificationInformation = async () => {
		try {
			const result = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/partner/certificates`);
			if (result.data.certificates) {
				setCertificates(result.data.certificates);
			}
		} catch (e) {
			const errorMessage = get(e, 'response.data.message', 'Something went wrong while fetching certificate information.');
			handleError(errorMessage);
			setCertificates(e);
		}
	};


	useEffect(() => {
		const fetchInfo = async () => {
			setAlertLoading(true);
			await Promise.all([
				fetchCertificationInformation(),
			]);
			setAlertLoading(false);
		};

		fetchInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!alertLoading) {

		//Error condition
		if (certificates instanceof Error) {
			return null;
		}
		const certsDetails = getActiveExpiredCertInfo(certificates);
		if (certificates.length > 0 && certsDetails.activeCerts > 0) {
			return certificates.map((certificateInformation) => {
				if (certificateInformation.status === 'active' && getExpiresIn(certificateInformation.expires) < 1) {
					return (
						<SdfAlert status='error' size='sm' aria-live="polite" className="mb-2">
							<RequestManageCertficate alertTitle={`Your security certificate ${certificateInformation.commonName} has expired`} alertBody={"Your organization's security certificate has expired. Please request a new ADP signed security certificate."} request={certificates.length < 10 && true} />
						</SdfAlert>
					)
				}

				if (certificateInformation.status === 'active' && getExpiresIn(certificateInformation.expires) <= 60 && getExpiresIn(certificateInformation.expires) >= 1) {
					return (
						<SdfAlert status='warning' size='sm' aria-live="polite" className="mb-2">
							<RequestManageCertficate alertTitle={`Your signed certificate ${certificateInformation.commonName} from ADP is expiring in ${getExpiresIn(certificateInformation.expires)} ${getExpiresIn(certificateInformation.expires) === 1 ? 'day' : 'days'}`} alertBody={"To prevent interruption of your integration(s), please request a new signed certificate from ADP."} request={certificates.length < 10 && true} />
						</SdfAlert>
					)
				}
				return null;
			})
		}

		else {
			return (
				<SdfAlert status='info' size='sm' aria-live="polite" className="mb-2">
					<RequestManageCertficate alertTitle={"Request or upload a security certificate"} alertBody={"A signed certificate from ADP is required to retrieve an access token."} request={true} />
				</SdfAlert>
			)
		}
	}

	else {
		return (<div>
			<SdfShimmer rows={2} />
		</div>)
	}
}

export default CertificateAlert;

